module.exports = __webpack_public_path__ + "img/s3-img5.f5dffbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s3-img5.png
// module id = 416
// module chunks = 0